var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"autoNumericInput",attrs:{"type":"text","placeholder":_vm.placeholder},on:{"keydown":_vm.setUserInteraction,"paste":_vm.setUserInteraction,"wheel":_vm.setUserInteraction,"drop":_vm.setUserInteraction,"keyup":_vm.resetUserInteraction,"blur":_vm.resetUserInteractionOnBlur,"autoNumeric:rawValueModified":_vm.updateVModel}})
}
var staticRenderFns = []

export { render, staticRenderFns }